import React from "react";
import PropTypes, { string } from "prop-types";
import Fieldset from "../common/Fieldset";
import Vraag from "./MinimaleEisenVraag";
import * as constants from "../../constants/DomainConstants";

const MinimaleEisenFieldset = (props) => {
    const {
        disabled,
        StartenWerkenNaUitersteIndieningsDatum,
        HeeftAanvragerLangdurigZakelijkRecht,
        InfrastructuurOpengesteldVoorBreedPubliek,
        InfrastructuurMarktconform,
        FinancieelDuurzaamEnHaalbaar,
        KanOmgevingsvergunningWordenBehaald,
        OpleveringBinnenDrieJaar,
        IsHetProjectEnergetischDuurzaam,
        MinimaalGeinvesteerd,
        typeDossier,
        onChange,
        errors,
        UitersteIndiendatum,
        MinSportgerelateerdeInvesteringenExclBtw
    } = props;

    const vragen = {
        StartenWerkenNaUitersteIndieningsDatum: "Starten de werken na ",
        HeeftAanvragerLangdurigZakelijkRecht: "Beschikt jouw project over een langduring zakelijk recht of eigenaarsschap?",
        InfrastructuurOpengesteldVoorBreedPubliek: "Is de infrastructuur opengesteld voor het brede publiek? ",
        InfrastructuurMarktconform: "Worden er marktconforme tarieven gehanteerd?",
        FinancieelDuurzaamEnHaalbaar: "Is het project financieel duurzaam en financieel haalbaar?",
        KanOmgevingsvergunningWordenBehaald: "Kan de omgevingsvergunning worden behaald?",
        OpleveringBinnenDrieJaar: "Kunnen de werken binnen 3.5 jaar voorlopig opgeleverd worden?",
        IsHetProjectEnergetischDuurzaam: "Is de sportinfrastructuur energetisch duurzaam?",
        MinimaalGeinvesteerd: `Wordt er minimaal €${MinSportgerelateerdeInvesteringenExclBtw} geïnvesteerd?`
    };

    const tooltips = {
        StartenWerkenNaUitersteIndieningsDatum: "Toegestaan: bouwrijp maken van terrein, ruimtelijk planningsproces, vergunningen, vooronderzoeken, ontwerp en studie, overheidsopdracht – opvragen offertes – gunning - onderhandelingen. Niet toegestaan: bouwen ",
        HeeftAanvragerLangdurigZakelijkRecht: "De subsidieaanvrager moet over het onroerend eigenaarschap, een zakelijk recht of voldoende garanties over één van deze twee laatsten beschikken. Voorbeelden zijn: erfpacht, onroerend vruchtgebruik, opstalrecht, erfdienstbaarheid, recht van gebruik en bewoning.",
        InfrastructuurOpengesteldVoorBreedPubliek: "Geen exclusiviteit.",
        InfrastructuurMarktconform: "In vergelijking met gelijkaardige sportinfrastructuur in de regio/buitenland.",
        FinancieelDuurzaamEnHaalbaar: "Met financieel duurzaam wordt bedoeld dat het totaal over een periode van 10 jaar van de exploitatie-inkomsten en uitgaven minstens “0” moet zijn. Met financieel haalbaar wordt bedoeld dat er een engagement moet zijn van 100% van het totaal aan sportgerelateerde investeringen rekening houdend met een eventuele subsidie van Sport Vlaanderen.",
        KanOmgevingsvergunningWordenBehaald: "De stedenbouwkundige voorschriften laten de activiteiten toe.",
        OpleveringBinnenDrieJaar: "De werken moeten binnen 3.5 jaar na de uiterlijke indiendatum van je aanvraagdossier voorlopig opgeleverd worden om in aanmerking te komen voor subsidies.",
        IsHetProjectEnergetischDuurzaam: "Als de sportinfrastructuur‚ waarvoor subsidie aangevraagd wordt, één of meer EPN—eenheden bevat‚ moeten de functionele delen waar de sport beoefend wordt, na de sportinfrastructuurwerken voldoen aan het E—peil dat van toepassing zal zijn één jaar na de datum van de aanvraag van de omgevingsvergunning voor stedenbouwkundige handelingen of de stedenbouwkundige vergunning. ",
        MinimaalGeinvesteerd: "Totaal aan sportgerelateerde investeringen over het totale project, exclusief btw."
    };

    const StartenWerkenNaUitersteIndieningsDatumProps = {
        disabled: disabled,
        label: vragen.StartenWerkenNaUitersteIndieningsDatum + UitersteIndiendatum + "?",
        value: StartenWerkenNaUitersteIndieningsDatum,
        tooltip: tooltips.StartenWerkenNaUitersteIndieningsDatum,
        fieldname: "startenWerkenNaUitersteIndieningsDatum",
        items: [{ label: "Ja", value: "true" }, { label: "Nee", value: "false" }],
        onChange: onChange,
        errors: errors
    };

    const HeeftAanvragerLangdurigZakelijkRechtProps = {
        disabled: disabled,
        label: vragen.HeeftAanvragerLangdurigZakelijkRecht,
        value: HeeftAanvragerLangdurigZakelijkRecht,
        tooltip: tooltips.HeeftAanvragerLangdurigZakelijkRecht,
        fieldname: "heeftAanvragerLangdurigZakelijkRecht",
        items: [{ label: "Ja", value: "true" }, { label: "Nee", value: "false" }],
        onChange: onChange,
        errors: errors
    };

    const InfrastructuurOpengesteldVoorBreedPubliekProps = {
        disabled: disabled,
        label: vragen.InfrastructuurOpengesteldVoorBreedPubliek,
        value: InfrastructuurOpengesteldVoorBreedPubliek,
        tooltip: tooltips.InfrastructuurOpengesteldVoorBreedPubliek,
        fieldname: "infrastructuurOpengesteldVoorBreedPubliek",
        items: [{ label: "Ja", value: "true" }, { label: "Nee", value: "false" }],
        onChange: onChange,
        errors: errors
    };

    const InfrastructuurMarktconformProps = {
        disabled: disabled,
        label: vragen.InfrastructuurMarktconform,
        value: InfrastructuurMarktconform,
        tooltip: tooltips.InfrastructuurMarktconform,
        fieldname: "infrastructuurMarktconform",
        items: [{ label: "Ja", value: "true" }, { label: "Nee", value: "false" }],
        onChange: onChange,
        errors: errors
    };

    const FinancieelDuurzaamEnHaalbaarProps = {
        disabled: disabled,
        label: vragen.FinancieelDuurzaamEnHaalbaar,
        value: FinancieelDuurzaamEnHaalbaar,
        tooltip: tooltips.FinancieelDuurzaamEnHaalbaar,
        fieldname: "financieelDuurzaamEnHaalbaar",
        items: [{ label: "Ja", value: "true" }, { label: "Nee", value: "false" }],
        onChange: onChange,
        errors: errors
    };

    const KanOmgevingsvergunningWordenBehaaldProps = {
        disabled: disabled,
        label: vragen.KanOmgevingsvergunningWordenBehaald,
        value: KanOmgevingsvergunningWordenBehaald,
        tooltip: tooltips.KanOmgevingsvergunningWordenBehaald,
        fieldname: "kanOmgevingsvergunningWordenBehaald",
        items: [{ value: "121450000", label: 'Ja' }, { value: "121450001", label: 'Nee' }],
        onChange: onChange,
        errors: errors
    };

    if (typeDossier == constants.DOSSIER_TYPE_AANVRAAG_BOVENLOKAAL_RENOVATIE) {
        KanOmgevingsvergunningWordenBehaaldProps.items = [{ value: "121450000", label: 'Ja' }, { value: "121450001", label: 'Nee' }, { value: "121450002", label: "Niet van toepassing" }];
    }

    const OpleveringBinnenDrieJaarProps = {
        disabled: disabled,
        label: vragen.OpleveringBinnenDrieJaar,
        value: OpleveringBinnenDrieJaar,
        tooltip: tooltips.OpleveringBinnenDrieJaar,
        fieldname: "opleveringBinnenDrieJaar",
        items: [{ label: "Ja", value: "true" }, { label: "Nee", value: "false" }],
        onChange: onChange,
        errors: errors
    };

    const IsHetProjectEnergetischDuurzaamProps = {
        disabled: disabled,
        label: vragen.IsHetProjectEnergetischDuurzaam,
        value: IsHetProjectEnergetischDuurzaam,
        tooltip: tooltips.IsHetProjectEnergetischDuurzaam,
        fieldname: "isHetProjectEnergetischDuurzaam",
        items: [{ value: "121450000", label: 'Ja' }, { value: "121450001", label: 'Nee' }, { value: "121450002", label: "Niet van toepassing" }],
        onChange: onChange,
        errors: errors
    };

    const MinimaalGeinvesteerdProps = {
        disabled: disabled,
        label: vragen.MinimaalGeinvesteerd,
        value: MinimaalGeinvesteerd,
        tooltip: tooltips.MinimaalGeinvesteerd,
        fieldname: "minimaalGeinvesteerd",
        items: [{ label: "Ja", value: "true" }, { label: "Nee", value: "false" }],
        onChange: onChange,
        errors: errors
    };

    return (<Fieldset title="Minimale Eisen">
        <Vraag {...StartenWerkenNaUitersteIndieningsDatumProps} />
        <Vraag {...HeeftAanvragerLangdurigZakelijkRechtProps} />
        <Vraag {...InfrastructuurOpengesteldVoorBreedPubliekProps} />
        <Vraag {...InfrastructuurMarktconformProps} />
        <Vraag {...FinancieelDuurzaamEnHaalbaarProps} />
        <Vraag {...KanOmgevingsvergunningWordenBehaaldProps} />
        <Vraag {...OpleveringBinnenDrieJaarProps} />
        <Vraag {...IsHetProjectEnergetischDuurzaamProps} />
        <Vraag {...MinimaalGeinvesteerdProps} />
    </Fieldset>);
};

MinimaleEisenFieldset.propTypes = {
    disabled: PropTypes.bool,
    StartenWerkenNaUitersteIndieningsDatum: PropTypes.bool,
    HeeftAanvragerLangdurigZakelijkRecht: PropTypes.bool,
    InfrastructuurOpengesteldVoorBreedPubliek: PropTypes.bool,
    InfrastructuurMarktconform: PropTypes.bool,
    FinancieelDuurzaamEnHaalbaar: PropTypes.bool,
    KanOmgevingsvergunningWordenBehaald: PropTypes.number,
    OpleveringBinnenDrieJaar: PropTypes.bool,
    IsHetProjectEnergetischDuurzaam: PropTypes.number,
    MinimaalGeinvesteerd: PropTypes.bool,
    onChange: PropTypes.func,
    errors: PropTypes.object,
    typeDossier: PropTypes.oneOf([constants.DOSSIER_TYPE_AANVRAAG_BOVENLOKAAL_NIEUWBOUW, constants.DOSSIER_TYPE_AANVRAAG_BOVENLOKAAL_RENOVATIE, constants.DOSSIER_TYPE_NEW_SIMULATIE]),
    UitersteIndiendatum: PropTypes.string,
    MinSportgerelateerdeInvesteringenExclBtw: PropTypes.string
};

export default MinimaleEisenFieldset;